/*
 * Page-level breadcrumb wrapper. Auto-picks the right console label and
 * nav tree from the current URL so individual pages just drop
 * <PageBreadcrumbs /> into their header — no per-page config.
 */

import Breadcrumbs from "./Breadcrumbs.js";
import { platformAdminNavigation } from "../navigation/platformAdminNavigation.js";
import { workspaceNavigation } from "../navigation/workspaceNavigation.js";
import { useLocation } from "react-router-dom";

export default function PageBreadcrumbs() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) {
    return <Breadcrumbs ctx={{ consoleLabel: "Admin", trees: [platformAdminNavigation] }} />;
  }
  if (location.pathname.startsWith("/app")) {
    return <Breadcrumbs ctx={{ consoleLabel: "Workspace", trees: [workspaceNavigation] }} />;
  }
  return null;
}
